module.exports = "<app-header (footerData)=\"footer.sendData($event)\"></app-header>\r\n<router-outlet></router-outlet>\r\n<app-footer #footer></app-footer>"